// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"n5-z","subtitle":"o5-z","wrapper":"p5-z","leftArrow":"q5-z","rightArrow":"r5-z"};